module.exports = __webpack_public_path__ + "static/images/red-task-bg2.8b310f2e2.png";